import { CommentContext } from '../../../../../../models/CommentHistory';
import { CommentContext as ApiCommentContext } from '../../Models/ApiResponse';
import { toComment } from '../ApiCommentConverter';
import { toPullRequest } from '../ApiPullRequestConverter';
import { toRepository } from '../ApiRepositoryConverter';

export function toCommentContext({
  comment,
  thread,
  pull_request,
  repository,
}: ApiCommentContext): CommentContext {
  return {
    comment: toComment(comment),
    thread: thread.map(toComment),
    pullrequest: toPullRequest(pull_request),
    repository: toRepository(repository),
  };
}
